define((require, exports, module) => {
    'use strict';

    function fixPhone(value) {
        return parseInt(value, 10)
            ? String(value).replace(/^([^8+])/, '+$1')
            : '';
    }

    module.exports = fixPhone;
});
